import React from 'react';
import styles from './ProductFeature.module.css';
import { Helmet } from "react-helmet-async";

const TimingGateFeature = () => {
  // Video Metadata for Google SEO
  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": "Aikyam Timing Gate - Ultimate Performance Measurement System",
    "description": "Elevate Your Training With The Timing Gate, The Ultimate Performance Measurement System For Athletes And Coaches. Designed For Speed, Agility, Reaction Time, And Jump Analysis.",
    "thumbnailUrl": [
      "https://img.youtube.com/vi/qRVyBfwPXBs/maxresdefault.jpg",
      "https://img.youtube.com/vi/qRVyBfwPXBs/hqdefault.jpg"
    ],
    "uploadDate": "2025-08-22T08:00:00+05:30", // Approximate date from your GSC logs
    "contentUrl": "https://www.youtube.com/watch?v=qRVyBfwPXBs",
    "embedUrl": "https://www.youtube.com/embed/qRVyBfwPXBs"
  };
  return (
    <>
    
      {/* Heading "FEATURES" */}
<Helmet>
  <script type="application/ld+json">
    {JSON.stringify(videoSchema)}
  </script>
</Helmet>
       <div id="timing-gate-video-section" className={styles.featureContainer}>
      <h2 className={styles.featuresHeading}>FEATURES</h2>

      {/* Main Content */}
      <div className={styles.featureContent}>
        {/* Left Section: Embedded YouTube Video */}
        <div className={styles.videoPlaceholder}>
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/qRVyBfwPXBs?autoplay=1&mute=1&loop=1&playlist=qRVyBfwPXBs&controls=0&showinfo=0&modestbranding=1&rel=0"
          title="Aikyam Timing Gate Performance Measurement System"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          style={{ borderRadius: '8px' }}
        ></iframe>

        </div>

        {/* Right Section: Feature List */}
        <div className={styles.featureList}>
          <p className={styles.featureText}>
            Elevate Your Training With
            <br />
            The Timing Gate, The Ultimate
            <br />
            Performance Measurement System
            <br />
            For Athletes And Coaches. Designed
            <br />
            For Speed, Agility, Reaction Time,
            <br />
            And Jump Analysis, Our Cutting-Edge
            <br />
            Technology Delivers Millisecond-
            <br />
            Accurate Data To Help You Train
            <br />
            Smarter, Perform Better, And
            <br />
            Dominate Your Sport.
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default TimingGateFeature;
